import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { SERVICE_INITIAL_STATE, ACTION_INITIAL_STATE } from './options';
export var calculateServiceState = function calculateServiceState(state) {
  var stateCopy = JSON.parse(JSON.stringify(state)); // leave only action related properties, delete global,
  // service related, that will be calculated by this function

  for (var key in SERVICE_INITIAL_STATE) {
    delete stateCopy[key];
  }

  var calculatedGlobalState = Object.entries(stateCopy).reduce(function (r, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        actionName = _ref2[0],
        actionState = _ref2[1];

    return _objectSpread({}, r, {
      isLoading: r.isLoading || actionState.isLoading,
      isError: r.isError || actionState.isError,
      touched: r.touched === null ? actionState.touched : r.touched < actionState.touched ? actionState.touched : r.touched
    });
  }, JSON.parse(JSON.stringify(SERVICE_INITIAL_STATE)));
  return _objectSpread({}, calculatedGlobalState, {}, stateCopy);
};
export default calculateServiceState;